@if (hero().widget; as widget) {
  <div class="hero-widget">
    <sc-placeholder name="hero-widget-dynamic" [rendering]="widget" />
  </div>
} @else {
  <div class="hero-widget__placeholder">
    <span>+ Add a widget</span>
  </div>
}
